/**
 * @generated SignedSource<<d9d46cbf42e0c0aaaf5ab67c41013bc2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type datalevel = "CJIS" | "EXTERNAL" | "INTERNAL" | "PRESALE" | "SECRET" | "TRIAL" | "UNKNOWN" | "%future added value";
export type docktype = "DOCK" | "G47" | "GROUND" | "PEDESTAL" | "UNKNOWN" | "%future added value";
export type orgtier = "BETA" | "EMPLOYEE" | "PROTECTED" | "T1" | "T2" | "T3" | "UNKNOWN" | "%future added value";
export type vehicletype = "C18" | "C36" | "C38" | "C93" | "DOCK_G27" | "DOCK_G47" | "E1" | "R1" | "R3" | "R47" | "R47_ISP" | "R47_XAVIER" | "R71" | "SIMULATOR" | "UNKNOWN" | "W17" | "%future added value";
export type OrganizationsPageQuery$variables = {
  count: number;
  cursor?: string | null;
  dataLevel?: datalevel | null;
  excludeDataLevel?: datalevel | null;
  excludeGroupUuids?: ReadonlyArray<string> | null;
  groupUuids?: ReadonlyArray<string> | null;
  hasDockTypes?: ReadonlyArray<docktype> | null;
  hasVehicleTypes?: ReadonlyArray<vehicletype> | null;
  noDockOfTypes?: ReadonlyArray<docktype> | null;
  noVehicleOfTypes?: ReadonlyArray<vehicletype> | null;
  orgTiers?: ReadonlyArray<orgtier> | null;
  searchTerm?: string | null;
};
export type OrganizationsPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OrganizationsPage_organizations">;
};
export type OrganizationsPageQuery = {
  response: OrganizationsPageQuery$data;
  variables: OrganizationsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dataLevel"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeDataLevel"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeGroupUuids"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupUuids"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasDockTypes"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasVehicleTypes"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noDockOfTypes"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noVehicleOfTypes"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgTiers"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v12 = {
  "kind": "Variable",
  "name": "dataLevel",
  "variableName": "dataLevel"
},
v13 = {
  "kind": "Variable",
  "name": "excludeDataLevel",
  "variableName": "excludeDataLevel"
},
v14 = {
  "kind": "Variable",
  "name": "excludeGroupUuids",
  "variableName": "excludeGroupUuids"
},
v15 = {
  "kind": "Variable",
  "name": "groupUuids",
  "variableName": "groupUuids"
},
v16 = {
  "kind": "Variable",
  "name": "hasDockTypes",
  "variableName": "hasDockTypes"
},
v17 = {
  "kind": "Variable",
  "name": "hasVehicleTypes",
  "variableName": "hasVehicleTypes"
},
v18 = {
  "kind": "Variable",
  "name": "noDockOfTypes",
  "variableName": "noDockOfTypes"
},
v19 = {
  "kind": "Variable",
  "name": "noVehicleOfTypes",
  "variableName": "noVehicleOfTypes"
},
v20 = {
  "kind": "Variable",
  "name": "orgTiers",
  "variableName": "orgTiers"
},
v21 = {
  "kind": "Variable",
  "name": "searchTerm",
  "variableName": "searchTerm"
},
v22 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v24 = [
  (v23/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrganizationsPageQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "OrganizationsPage_organizations"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v11/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/),
      (v7/*: any*/),
      (v9/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrganizationsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v22/*: any*/),
        "concreteType": "OrganizationConnection",
        "kind": "LinkedField",
        "name": "organizations",
        "plural": false,
        "selections": [
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "OrganizationEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "uuid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "VehicleConnection",
                    "kind": "LinkedField",
                    "name": "vehicles",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserConnection",
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DockConnection",
                    "kind": "LinkedField",
                    "name": "docks",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccessPointConnection",
                    "kind": "LinkedField",
                    "name": "accessPoints",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v22/*: any*/),
        "filters": [
          "searchTerm",
          "groupUuids",
          "excludeGroupUuids",
          "dataLevel",
          "excludeDataLevel",
          "orgTiers",
          "hasVehicleTypes",
          "noVehicleOfTypes",
          "hasDockTypes",
          "noDockOfTypes"
        ],
        "handle": "connection",
        "key": "OrganizationsList_organizations",
        "kind": "LinkedHandle",
        "name": "organizations"
      }
    ]
  },
  "params": {
    "cacheID": "1d2b80a7263bdf99f7fba9dfde62a2aa",
    "id": null,
    "metadata": {},
    "name": "OrganizationsPageQuery",
    "operationKind": "query",
    "text": "query OrganizationsPageQuery(\n  $count: Int!\n  $cursor: String\n  $searchTerm: String\n  $groupUuids: [String!]\n  $excludeGroupUuids: [String!]\n  $dataLevel: datalevel\n  $excludeDataLevel: datalevel\n  $orgTiers: [orgtier!]\n  $hasVehicleTypes: [vehicletype!]\n  $noVehicleOfTypes: [vehicletype!]\n  $hasDockTypes: [docktype!]\n  $noDockOfTypes: [docktype!]\n) {\n  ...OrganizationsPage_organizations_4xqkka\n}\n\nfragment OrganizationsPage_organization on Organization {\n  id\n  uuid\n  name\n  vehicles {\n    totalCount\n  }\n  users {\n    totalCount\n  }\n  docks {\n    totalCount\n  }\n  accessPoints {\n    totalCount\n  }\n}\n\nfragment OrganizationsPage_organizations_4xqkka on Query {\n  organizations(searchTerm: $searchTerm, groupUuids: $groupUuids, excludeGroupUuids: $excludeGroupUuids, dataLevel: $dataLevel, excludeDataLevel: $excludeDataLevel, orgTiers: $orgTiers, hasVehicleTypes: $hasVehicleTypes, noVehicleOfTypes: $noVehicleOfTypes, hasDockTypes: $hasDockTypes, noDockOfTypes: $noDockOfTypes, first: $count, after: $cursor) {\n    totalCount\n    edges {\n      node {\n        ...OrganizationsPage_organization\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "09bc6028680b300b5d2e9dcb50239528";

export default node;
